import React, { useState } from 'react'

import DashboardReport from './DashboardReport';
import DashboardProofSubmission from './DashboardProofSubmission';
import DashboardBoxes from './DashboardBoxes';
import Header from '../../components/Header'
import Footer from '../../components/Footer';
import HeaderInfo from '../../components/HeaderInfo';

import '../../assets/css/dashboard.css'

const Dashboard = () => {
  const [menuActive, setMenuActive] = useState(false);
  return (
    <div className='main-wrapper'>
      <Header activePage="dashboard" menuActive={menuActive} setMenuActive={setMenuActive} />
      <div className="main-content">
        <div className={`content-wrapper `}>
          <HeaderInfo title='Hey Admin' description='Manage users, track analytics, and keep everything running smoothly.'/>
          <DashboardReport />
          <DashboardBoxes />
          <DashboardProofSubmission />
        </div>
        <Footer menuActive={menuActive} />
      </div>
    </div>
  )
}

export default Dashboard
